import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Login from "./containers/Auth/Login";
import SignUp from "./containers/Auth/SignUp";
import { AuthProvider } from "./services/Authentication";
import ChatShell from './containers/shell/ChatShell'; 
import PrivateRoute from "./services/PrivateRoute";

const App = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    window.location.replace("https://www.nexto.pro/qrcode.html");
    return null;
  }
  return ( 
    <>
      <AuthProvider>
        <Router>
          <PrivateRoute exact path="/" component={ChatShell} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={SignUp} />
        </Router>
      </AuthProvider> 
    </>
  );
}

export default App;